angular.module('bmsApp.sm.quote')
	.controller('SMSelectTemplateModalCtrl', function ($scope,
															$modalInstance,
															$q,
															$ngBootbox,
													   		SMHouseTemplateSvc,
															TaxHelperSvc) {


		function init() {
			var promises = {
				houseTemplates: SMHouseTemplateSvc.index()
			};

			$q.all(promises).then(function(responses) {
				self.options.houseTemplates = responses.houseTemplates.data.house_template_collection;
				self.loading = false;
			});
		}

		function cancel() {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		}

		function submit() {
			if (self.formValidator.valid()) {
				var modalResult = {
					houseTemplate: self.houseTemplate
				};
				$modalInstance.close(modalResult);
			}
		}

		var self = $scope.SMSelectTemplateCtrl = {
			formvalidatorconfig: {},
			formValidator: {},
			loading: true,
			houseTemplate: null,
			processing: false,
			options: {},
			methods: {
				init: init,
				cancel: cancel,
				submit: submit
			}
		};


	});
